<template>
  <div class="busi-oppty-order-success">
    <EbHeader />
    <div class="panel-box order-success">
      <div class="order-success_org-name">
        {{success.orgName}} 信息推送，订单号{{success.sysOrderNumber}}
      </div>
      <br>
      <div class="order-success_msg">
        <i class="icon iconfont icon-prompt-success"></i>
        <div v-html="success.msg"></div>
      </div>
      <br>
      <div class="order-success_msg" v-if="!success.isSubscribe">
        <i class="icon iconfont icon-prompt-error"></i>
        <div v-html="success.subscribeMsg"></div>
      </div>
      <br>
      <div class="order-success_subscribe-doc" v-if="!success.isSubscribe">
        <h3>第一步</h3>
        <img src="/static/img/subscribe/step1.png" width="100%">
        <h3>第二步</h3>
        <img src="/static/img/subscribe/step2.jpg" width="100%">
        <h3>第三步</h3>
        <img src="/static/img/subscribe/step3.jpg" width="100%">
      </div>
    </div>
  </div>
</template>

<script>
import EbHeader from '@/components/common/eb-header';

export default {
  components: {
    EbHeader
  },
  data() {
    return {
      success: {}
    };
  },
  created() {
    this.success = JSON.parse(sessionStorage.getItem('busiOpptyOrderSuccess'));
    if (this.success == null) {
      this.success = {};
      // this.success = {
      //   msg: '您已成功订购信息推送服务12个月，有效期 2018/4/1～2019/3/31。<br>相关商机将推送至您的微信号“星尘”',
      //   orgName: '白云山集团',
      //   subscribeMsg:
      //     '您还没有关注易比得微信公众号，因此无法及时收到推送信息。请您参考下图：退出登录，使用微信扫码功能绑定微信号后，即可收到新的商机推送。',
      //   isSubscribe: false,
      //   sysOrderNumber: 'abc123123'
      // };
    }
  }
};
</script>

<style lang="less">
.busi-oppty-order-success {
  .order-success {
    .order-success_org-name {
      font-size: 20px;
      padding-left: 45px;
    }
    .order-success_msg {
      display: flex;
      .icon-prompt-success {
        font-size: 36px;
        color: #0f7f12;
      }
      .icon-prompt-error {
        font-size: 36px;
        color: #fc0d1b;
      }
      div {
        padding-left: 10px;
        line-height: 35px;
        font-size: 20px;
      }
    }
    .order-success_subscribe-doc {
      color: #fb5b3b;
      padding: 20px 10px;
    }
  }
}
</style>
